import { Row } from 'antd';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  padding-left: 30px;
  align-items: center;
`;

export const StatusWrapper = styled.div`
  margin-left: 30px;
`;

export const StyledRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
`;

export const TableContainer = styled.div`
  padding: 20px 30px;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  ${/*sc-selector*/ StyledRow}:last-child {
    border-bottom: 0;
  }
`;

export const HeaderCell = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AttrLabel = styled(HeaderCell)`
  text-transform: uppercase;
`;

export const AttrValue = styled(HeaderCell)`
  font-weight: 600;
`;

export const PrevAttrValue = styled(HeaderCell)`
  text-decoration: line-through;
`;

export const ErrorsList = styled.ul`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  list-style-type: disc;
  font-size: 0.8rem;
  margin-left: 15px;
`;

export const EmailString = styled.span`
  font-size: 1rem;
  font-weight: normal;
  color: ${({ theme }) => theme.baseBlue.a6};
`;
